import { Box, Chip } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { notasByBloquesPedagogicos } from '../../../boletines/BoletinesHelper';
import PlanesEvaluacionesNotas from '../../../boletines/components/PlanesEvaluacionesNotas';

const NotasEvaluativasEstudianteComponent = () => {
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );
  const [materias, setMaterias] = React.useState([]);

  function _hanlderMaterias() {
    const materiasArray = notasByBloquesPedagogicos(
      bloquesPedagogicosStore.all,
      planEvaluacionStore.all,
      estudiantesStore.notasEvaluativas,
      estudiantesStore.actividadesExtras,
    );
    setMaterias(materiasArray);
  }

  React.useEffect(() => {
    _hanlderMaterias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ display: 'flex' }}>
      {planEvaluacionStore.all.length > 0 ? (
        <PlanesEvaluacionesNotas
          type={2}
          materias={materias}
          planesEvaluacion={planEvaluacionStore.all}
          notasEvaluativas={estudiantesStore.notasEvaluativas}
          actividadesExtras={estudiantesStore.actividadesExtras}
        />
      ) : (
        <Box padding={2}>
          <Chip
            color="primary"
            label="No tiene planes de evaluaciones asignado"
          />
        </Box>
      )}
    </Box>
  );
};

export default NotasEvaluativasEstudianteComponent;
